export function formatDistance(distanceInMiles: number) {
  if (distanceInMiles == null || distanceInMiles < 0) {
    return ''
  }

  const FEET_IN_MILE = 5280
  const WALKING_MIN_PER_MILE = 20
  const MAX_WALK_MINUTES = 30

  let distanceLabel = ''

  if (distanceInMiles < 0.2) {
    const feet = Math.max(
      1,
      Math.round(distanceInMiles * FEET_IN_MILE)
    )
    distanceLabel = `${feet} ft`
  } else {
    distanceLabel = `${Math.round(distanceInMiles * 100) / 100} mi`
  }

  const rawWalkingMinutes = Math.max(
    1,
    Math.round(distanceInMiles * WALKING_MIN_PER_MILE)
  )

  let timeLabel = ''

  if (rawWalkingMinutes > MAX_WALK_MINUTES) {
    timeLabel = `> ${MAX_WALK_MINUTES} min`
  } else {
    timeLabel =
      rawWalkingMinutes === 1
        ? '1 min'
        : `${rawWalkingMinutes} min`
  }

  return `${timeLabel} (${distanceLabel})`
}